import store from '@/store'

import utility from '@/mixins/utility'

class Menu {

  #data = {}

  #children = []

  #badge = null

  // app has been opened?
  #open = false

  // app iframe is visible?
  #status = false

  constructor(data={})
  {
    this.#data = data

    if( data.children )
      this.#children = utility.methods.mapModels(data.children, 'menu')

      if( data.badge )
      this.#badge = utility.methods.mapModel(data.badge, 'badge')
  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active == true
  }

  get blank()
  {
    return this.#data.blank == true
  }

  get cardCss()
  {
    return this.#data.card_color
  }

  get cardImage()
  {
    return this.#data.card_image
  }

  get description()
  {
    return this.#data.description
  }

  get disabled()
  {
    return this.#data.disabled == true
  }

  get domain()
  {
    return this.#data.domain
  }

  get icon()
  {
    return this.#data.icon
  }

  get id()
  {
    return this.#data.id
  }

  get image()
  {
    return this.#data.image
  }

  get label()
  {
    return this.#data.label
  }

  get position()
  {
    return this.#data.position
  }

  get url()
  {
    return this.#data.url
  }  

  /**
   * Computed properties.
   */

  get hasChildren()
  {
    return this.#children.length > 0
  }
  
  get isOpen()
  {
    // apps that open in new window?
    return this.blank ? true : this.#open
  }
  
  get isVisible()
  {
    return this.#status
  }

  get urlWithToken()
  {
    const param = 'zwan_spaces_id',
          token = store.getters['auth/apiToken']

    let url = this.url

    if( url.indexOf('?') >= 0 )
      url += `&${param}=${token}`

    else
      url += `?${param}=${token}`

    return url
  }
  

  /**
   * Relationships.
   */
  
  get badge()
  {
    return this.#badge
  }

  get children()
  {
    return this.#children
  }

  /**
   * Methods.
   */
  
  open()
  {
    this.#open = true
  }
  
  show()
  {
    this.#status = true
  }

  hide()
  {
    this.#status = false
  }

  toggle()
  {
    this.#status = !this.#status
  }

  setUrl(url)
  {
    this.#data.url = url

    return this
  }

}

export default Menu